// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.
export * from './chromosome/chromosome.util';
export * from './deep-equal/deep-equal.util';
export * from './key-comparator/key-comparator.util';
export * from './number/number.util';
export * from './tsv/tsv.util';

import { ChromosomeUtil } from './chromosome/chromosome.util';
import { deepEqual } from './deep-equal/deep-equal.util';
import { KeyComparatorFactory } from './key-comparator/key-comparator.util';
import { NumberUtil } from './number/number.util';
import { TsvUtil } from './tsv/tsv.util';

export const Utils = {
  chromosome: ChromosomeUtil,
  deepEqual,
  keyComparator: KeyComparatorFactory,
  number: NumberUtil,
  tsv: TsvUtil,
} as const;
